import {
  LOADING_UI,
  UPLOAD_IMAGES,
  SET_HIDE_URL,
  SET_POSTS,
  SET_DESIGN_COLORS,
  SET_COLOR_PALETTES,
  SET_FONT_ADJUSTMENT,
  SET_IMAGE_POSITION,
  SET_IS_RANDOM_IMAGES,
  SET_IS_RANDOM_TEMPLATES,
  SET_TEMPLATE_SELECTIONS,
  REMOVE_FROM_TEMPLATE_SELECTIONS,
  SET_IS_GENERATING,
  SET_USE_ALL_COLORS,
  SET_SELECTED_COLOR_INDEX,
  SET_FONT_FAMILY,
  SET_FONT_COLOR,
  SET_USE_UPPER_CASE_FONT,
  SET_GET_IMAGES_IN_ARTICLE,
  SET_DESIGN_SETTINGS,
  SET_IS_CONTAIN_IMAGES,
  SET_POST_OVERRIDES,
  SET_ETSY_STORE_NAME,
  UPDATE_SINGLE_POST,
  UPDATE_SINGLE_POST_LAYER,
  SET_OVERRIDE_COLORS_AND_FONT,
  RESET_DESIGN_SETTINGS,
  USE_ONE_OF_EACH_TEMPLATE_CHANGE,
  UPDATE_POST_TEMPLATE_LAYER,
  DUPLICATE_POST,
  DELETE_POST,
  ADD_POSTS,
  SET_USE_ALL_DETECTED_IMAGES,
  SET_SELECTED_DETECTED_IMAGES,
  TOGGLE_SELECTED_DETECTED_IMAGES,
  SET_LOADING_DESIGN_SETTINGS,
  CREATE_POSTS_WITH_DESIGN_SETTINGS,
  SET_SELECTED_UPLOADED_IMAGES,
  TOGGLE_SELECTED_UPLOADED_IMAGES,
  SET_AI_LANGUAGE,
  SET_AI_KEYWORDS,
  SET_AI_TONE,
  SET_AI_IMAGE_CUSTOM_PROMPT,
  SET_SHOW_AI_IMAGE_CUSTOM_PROMPT,
  SET_INCLUDE_URL_IN_POST_TEXT,
  SET_AI_INCLUDE_HASHTAGS,
  SET_UPLOADED_FONTS,
  ADD_UPLOADED_FONT,
  DELETE_UPLOADED_FONT,
  SET_FIX_LOW_CONTRAST_TEXT,
  SET_USE_ONE_OF_EACH_IMAGE,
  SET_GROUP_POSTS_BY,
  SET_SHOW_POST_TEXT,
  DELETE_SINGLE_POST_LAYER,
  SET_SELECTED_LAYER_ID,
  SET_TEMPLATES,
  SET_IS_LOADING_USER_TEMPLATES,
  SET_DESIGN_SETTINGS_PROFILES,
  RENAME_DESIGN_PROFILE,
  DELETE_DESIGN_PROFILE,
  SET_PICKED_TEMPLATE,
  SET_BYPASSS_RESIZE,
  SET_GENERATE_ALT_TEXT_WITH_AI,
  INCREMENT_USED_POST_CREDITS,
} from "../types";

import axios from "axios";
import config from "../../utils/config";
export const uploadImages = (imageFiles) => (dispatch) => {
  dispatch({
    type: UPLOAD_IMAGES,
    payload: imageFiles,
  });
};

export const setHideURL = (hideURL) => (dispatch) => {
  dispatch({
    type: SET_HIDE_URL,
    payload: hideURL,
  });
};

export const setPosts = (posts) => (dispatch) => {
  dispatch({
    type: SET_POSTS,
    payload: posts,
  });
};

export const duplicatePost = (postIndex) => (dispatch) => {
  dispatch({
    type: DUPLICATE_POST,
    payload: postIndex,
  });
};

export const addPosts = (post) => (dispatch) => {
  dispatch({
    type: ADD_POSTS,
    payload: post,
  });
};

export const deletePost = (postIndex) => (dispatch) => {
  dispatch({
    type: DELETE_POST,
    payload: postIndex,
  });
};

export const setDesignColors = (colors) => (dispatch) => {
  dispatch({
    type: SET_DESIGN_COLORS,
    payload: colors,
  });
};

export const setColorPalettes = (colorPalettes) => (dispatch) => {
  dispatch({
    type: SET_COLOR_PALETTES,
    payload: colorPalettes,
  });
};

export const setFontColor = (color) => (dispatch) => {
  dispatch({
    type: SET_FONT_COLOR,
    payload: color,
  });
};

export const setUseAllColors = (useAllColors) => (dispatch) => {
  dispatch({
    type: SET_USE_ALL_COLORS,
    payload: useAllColors,
  });
};

export const setSelectedColorIndex = (selectedColorIndex) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_COLOR_INDEX,
    payload: selectedColorIndex,
  });
};

export const setFontAdjustment = (size) => (dispatch) => {
  dispatch({
    type: SET_FONT_ADJUSTMENT,
    payload: size,
  });
};

export const setImagePosition = (position) => (dispatch) => {
  dispatch({
    type: SET_IMAGE_POSITION,
    payload: position,
  });
};

export const setIsRandomImages = (isRandom) => (dispatch) => {
  dispatch({
    type: SET_IS_RANDOM_IMAGES,
    payload: isRandom,
  });
};

export const setIsRandomTemplates = (isRandomTemplates) => (dispatch) => {
  dispatch({
    type: SET_IS_RANDOM_TEMPLATES,
    payload: isRandomTemplates,
  });
};

export const setTemplateSelections = (templates) => (dispatch) => {
  dispatch({
    type: SET_TEMPLATE_SELECTIONS,
    payload: templates,
  });
};

export const removeFromTemplateSelections = (templateId) => (dispatch) => {
  dispatch({
    type: REMOVE_FROM_TEMPLATE_SELECTIONS,
    payload: templateId,
  });
};

export const setIsGenerating = (isGenerating) => (dispatch) => {
  dispatch({
    type: SET_IS_GENERATING,
    payload: isGenerating,
  });
};

export const setFontFamily = (fontFamily, fontUrl) => (dispatch) => {
  dispatch({
    type: SET_FONT_FAMILY,
    payload: { fontFamily, fontUrl },
  });
};

export const setUseUpperCaseFont = (useUpperCaseFont) => (dispatch) => {
  dispatch({
    type: SET_USE_UPPER_CASE_FONT,
    payload: useUpperCaseFont,
  });
};

export const getDesignSettingsProfiles = (handle) => (dispatch) => {
  dispatch({
    type: SET_LOADING_DESIGN_SETTINGS,
    payload: true,
  });

  return new Promise((resolve) => {
    axios
      .get(`/api/user/getDesignSettingsProfiles/${handle}`)
      .then((res) => {
        let { designSettingsProfiles, activeDesignSettings } = res.data;

        dispatch({
          type: SET_DESIGN_SETTINGS_PROFILES,
          payload: designSettingsProfiles,
        });

        dispatch({
          type: SET_DESIGN_SETTINGS,
          payload: activeDesignSettings,
        });

        resolve(activeDesignSettings);
      })
      .catch((err) => {
        console.error("Unable to load design settings: ", err);

        resolve({
          type: "error",
          text: `Unable to load design settings: ${err}`,
        });
      })
      .finally(() => {
        dispatch({
          type: SET_LOADING_DESIGN_SETTINGS,
          payload: false,
        });
      });
  });
};

export const setDesignSettingsProfile = (profileName) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/api/user/getDesignSettingsProfile/${encodeURIComponent(profileName)}`
      )
      .then((res) => {
        let { designProfiles, designSettingsProfile } = res.data;

        dispatch({
          type: SET_DESIGN_SETTINGS,
          payload: designSettingsProfile,
        });

        dispatch({
          type: SET_DESIGN_SETTINGS_PROFILES,
          payload: designProfiles,
        });

        resolve(designSettingsProfile);
      })
      .catch((err) => {
        console.error("Unable to load design settings: ", err);
        reject("Unable to load design settings: ", err);
      });
  });
};

export const renameDesignProfile =
  ({ newProfileName, profileId }) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/user/renameDesignProfile`, {
          newProfileName,
          profileId,
        })
        .then((res) => {
          console.log("renameDesignProfile", res.data);
          resolve("Design profile renamed");

          dispatch({
            type: RENAME_DESIGN_PROFILE,
            payload: {
              newProfileName,
              profileId,
            },
          });
        })
        .catch((err) => {
          console.error("Unable to rename design profile: ", err);
          reject("Unable to rename design profile: ", err);
        });
    });
  };

export const createPostsWithDesignSettings =
  (userTemplates, standardTemplates) => (dispatch) => {
    dispatch({
      type: CREATE_POSTS_WITH_DESIGN_SETTINGS,
      payload: {
        userTemplates,
        standardTemplates,
      },
    });
  };

export const saveDesignSettings = (designSettings) => (dispatch) => {
  // Create deep copy
  let settings = JSON.parse(JSON.stringify(designSettings));

  // Remove unneeded items from design settings
  delete settings.posts;
  delete settings.isGenerating;
  delete settings.uploadedImages;
  delete settings.fontAdjustment;
  delete settings.useAllDetectedImages;
  delete settings.selectedDetectedImages;
  delete settings.selectedUploadedImages;
  delete settings.designSettingsProfiles;
  delete settings.bypassResize;
  delete settings.designProfilesLoaded;

  // remove unneeded items from post overrides
  settings.postOverrides = {
    brandName: settings.postOverrides.brandName,
    logoImage: settings.postOverrides.logoImage,
  };

  return new Promise((resolve, reject) => {
    axios
      .post("/api/user/saveDesignSettings", settings)
      .then((res) => {
        if (res.data.newProfileName) {
          // set design settings profile
          dispatch(setDesignSettingsProfile(res.data.newProfileName));
        }
        resolve("Design settings saved");
      })
      .catch((err) => {
        reject(`Unable to save design settings: ${err}`);
      });
  });
};

export const deleteDesignProfile = (profileIdToDelete) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/user/deleteDesignProfile/${profileIdToDelete}`)
      .then((res) => {
        resolve("Design profile deleted");

        dispatch({
          type: DELETE_DESIGN_PROFILE,
          payload: profileIdToDelete,
        });
      })
      .catch((err) => {
        console.error("Unable to delete design profile: ", err);
        reject("Unable to delete design profile: ", err);
      });
  });
};

export const setDesignSettings = (designSettings) => (dispatch) => {
  dispatch({
    type: SET_DESIGN_SETTINGS,
    payload: designSettings,
  });
};

export const setIsContainImages = (isContainImages) => (dispatch) => {
  dispatch({
    type: SET_IS_CONTAIN_IMAGES,
    payload: isContainImages,
  });
};

export const setPostOverrides = (overrideObject) => (dispatch) => {
  dispatch({
    type: SET_POST_OVERRIDES,
    payload: overrideObject,
  });
};

export const setEtsyStoreName = (storeName) => (dispatch) => {
  dispatch({
    type: SET_ETSY_STORE_NAME,
    payload: storeName,
  });
};

export const updateSinglePost = (index, updateValues) => (dispatch) => {
  dispatch({
    type: UPDATE_SINGLE_POST,
    payload: {
      index,
      updateValues,
    },
  });
};

function postWithGeneratedImage(post, imageUrl) {
  const existingImages = Array.isArray(post.allImages) ? post.allImages : [];
  const allImages = [
    imageUrl,
    ...existingImages.filter((image) => image && image !== imageUrl),
  ];

  let template = post.template;
  if (template && Array.isArray(template.layers)) {
    let appliedToDetectedLayer = false;
    const layers = template.layers.map((layer) => {
      const isImageLayer =
        layer.type === "Image" ||
        (layer.type === "SVG" && layer.containsImage);
      if (!isImageLayer || !layer.useDetectedImages) {
        return layer;
      }

      appliedToDetectedLayer = true;
      if (layer.type === "Image") {
        return { ...layer, src: imageUrl };
      }
      return { ...layer, imageSrc: imageUrl };
    });

    if (!appliedToDetectedLayer) {
      const firstImageIndex = layers.findIndex((layer) => layer.type === "Image");
      if (firstImageIndex !== -1) {
        layers[firstImageIndex] = {
          ...layers[firstImageIndex],
          src: imageUrl,
        };
      }
    }

    template = { ...template, layers };
  }

  const update = {
    allImages,
    image: imageUrl,
  };
  if (template) {
    update.template = template;
  }
  return update;
}

export const applyGeneratedImageToPost =
  (postId, imageUrl, fallbackIndex) => (dispatch, getState) => {
    if (!imageUrl) return false;

    const posts = getState().design.posts || [];
    let index = posts.findIndex((post) => post && post.id === postId);
    if (
      index === -1 &&
      Number.isInteger(fallbackIndex) &&
      fallbackIndex >= 0 &&
      fallbackIndex < posts.length
    ) {
      index = fallbackIndex;
    }
    if (index === -1) return false;

    dispatch(
      updateSinglePost(
        index,
        postWithGeneratedImage(posts[index], imageUrl),
      ),
    );
    return true;
  };

export const updateSinglePostLayer =
  (postId, layerId, layerUpdates) => (dispatch) => {
    dispatch({
      type: UPDATE_SINGLE_POST_LAYER,
      payload: {
        postId,
        layerId,
        layerUpdates,
      },
    });
  };

export const deleteSinglePostLayer = (postId, layerId) => (dispatch) => {
  dispatch({
    type: DELETE_SINGLE_POST_LAYER,
    payload: {
      postId,
      layerId,
    },
  });

  dispatch({ type: SET_SELECTED_LAYER_ID, payload: null });
};

export const updatePostTemplateLayer =
  (postId, layerId, layerUpdates) => (dispatch) => {
    dispatch({
      type: UPDATE_POST_TEMPLATE_LAYER,
      payload: {
        postId,
        layerId,
        layerUpdates,
      },
    });
  };

export const setOverrideColorsAndFont =
  (overrideColorsAndFonts) => (dispatch) => {
    dispatch({
      type: SET_OVERRIDE_COLORS_AND_FONT,
      payload: overrideColorsAndFonts,
    });
  };

export const resetDesignSettings = () => (dispatch) => {
  dispatch({ type: RESET_DESIGN_SETTINGS });

  return Promise.resolve();
};

export const setUseOneOfEachTemplate = (useOneOfEachTemplate) => (dispatch) => {
  dispatch({
    type: USE_ONE_OF_EACH_TEMPLATE_CHANGE,
    payload: useOneOfEachTemplate,
  });
};

// This function does not need to be mapped to props because it is only used in this file
export const rewriteText = (
  prompt,
  numResults,
  email,
  logPrompt = false,
  context = "",
  maxCharacters = null
) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/openAI/rewriteText", {
        prompt,
        numResults,
        logPrompt,
        context,
        maxCharacters,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

// This function does not need to be mapped to props because it is only used in this file
export const rewriteTextNoDuplicates = (prompt, numResults) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/highMemLimitApi/openAI/rewriteTextNoDuplicates", {
        prompt,
        numResults,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

export const rewriteTextNoDuplicatesFree = (prompt, numResults) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/highMemLimitApi/openAI/rewriteTextNoDuplicatesFree", {
        prompt,
        numResults,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};

export const setUseAllDetectedImages = (useAllDetectedImages) => (dispatch) => {
  dispatch({
    type: SET_USE_ALL_DETECTED_IMAGES,
    payload: useAllDetectedImages,
  });
};

export const setSelectedDetectedImages = (imageArray) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_DETECTED_IMAGES,
    payload: imageArray,
  });
};

export const toggleSelectedDetectedImage = (image) => (dispatch) => {
  dispatch({
    type: TOGGLE_SELECTED_DETECTED_IMAGES,
    payload: image,
  });
};

export const setSelectedUploadedImages = (imageArray) => (dispatch) => {
  dispatch({
    type: SET_SELECTED_UPLOADED_IMAGES,
    payload: imageArray,
  });
};

export const toggleSelectedUploadedImage = (image) => (dispatch) => {
  dispatch({
    type: TOGGLE_SELECTED_UPLOADED_IMAGES,
    payload: image,
  });
};

export const setUseOneOfEachImage = (useOneOfEachImage) => (dispatch) => {
  dispatch({
    type: SET_USE_ONE_OF_EACH_IMAGE,
    payload: useOneOfEachImage,
  });
};

export const setAILanguage = (language) => (dispatch) => {
  dispatch({
    type: SET_AI_LANGUAGE,
    payload: language,
  });
};

export const setAIKeywords = (keywords) => (dispatch) => {
  dispatch({
    type: SET_AI_KEYWORDS,
    payload: keywords,
  });
};

export const setAITone = (tone) => (dispatch) => {
  dispatch({
    type: SET_AI_TONE,
    payload: tone,
  });
};

export const setAIImageCustomPrompt = (customPrompt) => (dispatch) => {
  dispatch({
    type: SET_AI_IMAGE_CUSTOM_PROMPT,
    payload: customPrompt,
  });
};

export const setShowAIImageCustomPrompt = (show) => (dispatch) => {
  dispatch({
    type: SET_SHOW_AI_IMAGE_CUSTOM_PROMPT,
    payload: show,
  });
};

export const setIncludeURLInPostText = (includeURL) => (dispatch) => {
  dispatch({
    type: SET_INCLUDE_URL_IN_POST_TEXT,
    payload: includeURL,
  });
};

export const setAIIncludeHashtags = (includeHashtags) => (dispatch) => {
  dispatch({
    type: SET_AI_INCLUDE_HASHTAGS,
    payload: includeHashtags,
  });
};

export const setUploadedFonts = (fonts) => (dispatch) => {
  dispatch({
    type: SET_UPLOADED_FONTS,
    payload: fonts,
  });
};

export const addUploadedFont = (font) => (dispatch) => {
  dispatch({
    type: ADD_UPLOADED_FONT,
    payload: font,
  });
};

export const deleteFont = (id) => (dispatch) => {
  dispatch({ type: DELETE_UPLOADED_FONT, payload: id });

  axios
    .delete(`/api/user/media/deleteMedia/${id}`)
    .then((res) => {
      //console.log("Font deleted");
    })
    .catch((err) => {
      console.error("Unable to delete font: ", err);
    });
};

export const setFixLowContrastText = (fixLowContrastText) => (dispatch) => {
  dispatch({
    type: SET_FIX_LOW_CONTRAST_TEXT,
    payload: fixLowContrastText,
  });
};

export const setPickedTemplate = (template) => (dispatch) => {
  dispatch({
    type: SET_PICKED_TEMPLATE,
    payload: template,
  });
};

export const setBypassResize = (bypassResize) => (dispatch) => {
  dispatch({
    type: SET_BYPASSS_RESIZE,
    payload: bypassResize,
  });
};

export const setGenerateAltTextWithAI =
  (generateAltTextWithAI) => (dispatch) => {
    dispatch({
      type: SET_GENERATE_ALT_TEXT_WITH_AI,
      payload: generateAltTextWithAI,
    });
  };

export const prepareAltText =
  (currentAltText, generateAltTextWithAI, aiLanguage, generatedPostURL) =>
  (dispatch) => {
    return new Promise(async (resolve, reject) => {
      // Protect against undefined
      let altText = currentAltText ? currentAltText : "";

      if (generateAltTextWithAI) {
        getAltTextFromImage(generatedPostURL, aiLanguage)
          .then((altText) => {
            // Increment used post credits
            dispatch({
              type: INCREMENT_USED_POST_CREDITS,
              payload: config.creditUsage.aiAltText,
            });

            resolve(altText);
          })
          .catch((err) => {
            console.error("Unable to get alt text from AI: " + err);
            resolve(altText);
          });
      } else {
        resolve(altText);
      }
    });
  };

export function getAltTextFromImage(imageURL, aiLanguage = "English") {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/openAI/getAltTextFromImage", {
        imageURL,
        aiLanguage,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
}

export const setGroupPostsBy = (groupBy) => (dispatch) => {
  dispatch({
    type: SET_GROUP_POSTS_BY,
    payload: groupBy,
  });
};

export const setShowPostText = (showPostText) => (dispatch) => {
  dispatch({
    type: SET_SHOW_POST_TEXT,
    payload: showPostText,
  });
};
